export interface ArbitroDisponibilidadHorariaJSON {
  arbdh_id: string | null;
  arbdh_arbid: string;
  arbdh_dia_semana: number;
  arbdh_disponible: any;
  arbdh_fulltime: any;
  arbdh_consultar: any;
  arbdh_hora_desde: any;
  arbdh_hora_hasta: any;
  __delete: boolean;
}

export class ArbitroDisponibilidadHoraria {
  protected constructor(
    private id: string | null,
    private arbid: string,
    private diaSemana: number,
    private disponible: any,
    private fulltime: any,
    private consultar: any,
    private horaDesde: any,
    private horaHasta: any,
    private __delete: boolean
  ) {}

  static createFrom(
    id: string | null,
    arbid: string,
    diaSemana: number,
    disponible: any,
    fulltime: any,
    consultar: any,
    horaDesde: any,
    horaHasta: any,
    __delete: boolean
  ) {
    return new this(id, arbid, diaSemana, disponible, fulltime, consultar, horaDesde, horaHasta, __delete);
  }

  isIdentifiedBy(anId: string): boolean {
    return this.id === anId;
  }

  isIdentifiedAs(aEntity: ArbitroDisponibilidadHoraria) {
    if (this.id) {
      return aEntity.isIdentifiedBy(this.id);
    } else {
      return false;
    }
  }

  static fromJSON(entity: ArbitroDisponibilidadHorariaJSON) {
    return ArbitroDisponibilidadHoraria.createFrom(
      entity.arbdh_id,
      entity.arbdh_arbid,
      entity.arbdh_dia_semana,
      entity.arbdh_disponible,
      entity.arbdh_fulltime,
      entity.arbdh_consultar,
      entity.arbdh_hora_desde,
      entity.arbdh_hora_hasta,
      entity.__delete
    );
  }

  toJSON(): ArbitroDisponibilidadHorariaJSON {
    return {
      arbdh_id: this.getId(),
      arbdh_arbid: this.getArbid(),
      arbdh_dia_semana: this.getDiaSemana(),
      arbdh_disponible: this.getDisponible(),
      arbdh_fulltime: this.getFulltime(),
      arbdh_consultar: this.getConsultar(),
      arbdh_hora_desde: this.getHoraDesde(),
      arbdh_hora_hasta: this.getHoraHasta(),
      __delete: this.get__delete(),
    };
  }

  getId(): string | null {
    return this.id;
  }

  getArbid(): string {
    return this.arbid;
  }

  getDiaSemana(): number {
    return this.diaSemana;
  }

  getDisponible(): any {
    return this.disponible;
  }

  getFulltime(): any {
    return this.fulltime;
  }

  getConsultar(): any {
    return this.consultar;
  }

  getHoraDesde(): any {
    return this.horaDesde;
  }

  getHoraHasta(): any {
    return this.horaHasta;
  }

  get__delete(): boolean {
    return this.__delete;
  }

  setId(value: string | null): void {
    this.id = value;
  }

  setArbid(value: string): void {
    this.arbid = value;
  }

  setDiaSemana(value: number): void {
    this.diaSemana = value;
  }

  setDisponible(value: any): void {
    this.disponible = value;
  }

  setFulltime(value: any): void {
    this.fulltime = value;
  }

  setConsultar(value: any): void {
    this.consultar = value;
  }

  setHoraDesde(value: any): void {
    this.horaDesde = value;
  }

  setHoraHasta(value: any): void {
    this.horaHasta = value;
  }

  set__delete(value: boolean): void {
    this.__delete = value;
  }
}
